import Form, { ClientDescriptionFormMode } from "./Form";
import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import GenericDialog from "../GenericDialog";

export default function Edit({ open, setOpen, entry, onEdit }) {
  const { homeDispatch } = useContext(HomeAppContext);

  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState([]);
  const [descriptionNeedsReviewed, setdescriptionNeedsReviewed] = useState(false);
  const [tagsFromApi, setTagsFromApi] = useState([]);
  const [familiesFromApi, setFamiliesFromApi] = useState([]);

  React.useEffect(() => {
    if (entry !== null && open) {
      setInternalEntry(entry);
      setErrors([]);
      setLoading(false);
      setSubmitted(false);
      // setdescriptionNeedsReviewed(true);
    } else {
      setInternalEntry(null);
    }
  }, [entry, open]);

  const getTags = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Fetching client description tags", loading: true }
    });
    api
      .get("/api/client-descriptions/tags/dropdown")
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: { message: "Client Description tags fetched successfuly", type: "success" }
        });
        setTagsFromApi(r.data);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };

  const getEngineFamilies = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Fetching engine families", loading: true }
    });
    api
      .get("/api/client-descriptions/family/dropdown")
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Engine families fetched successfuly",
            type: "success"
          }
        });
        setFamiliesFromApi(r.data);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
    setInternalEntry(null);
  };

  const handleReviewdescription = () => {
    const reviewDto = {
      clientDescriptionClients: internalEntry.clientDescriptionClients.map((e) => e.id),
      name: internalEntry.name,
      description: internalEntry.description,
      provider: internalEntry.provider,
    };
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Reviewing client description", loading: true }
    });
    api
      .post("/api/client-descriptions/review-client description", reviewDto)
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Reviewing client description success",
            type: "success"
          }
        });
        setdescriptionNeedsReviewed(false);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };

  const handleCloseSave = () => {
    const updatedescription = {
      id: internalEntry.id,
      clientDescriptionClients: internalEntry.clientDescriptionClients.map((e) => e.id),
      name: internalEntry.name,
      description: internalEntry.description,
      provider: internalEntry.provider,
    };

    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Updating " + internalEntry.name, loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    api
      .put(`/api/client-descriptions/${updatedescription.id}`, updatedescription)
      .then(() => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: internalEntry.name + " updated!",
            type: "success"
          }
        });
        setOpen(false);
        setLoading(false);
        onEdit();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      {descriptionNeedsReviewed === true ? (
        <Button
          onClick={handleReviewdescription}
          variant="outlined"
          color="primary"
        >
          Review Client Description
        </Button>
      ) : (
        <Button
          onClick={handleCloseSave}
          color="primary"
          variant="outlined"
          autoFocus
          disabled={loading || saveDisabled}
        >
          Save Client Description
        </Button>
      )}
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      maxWidth={"lg"}
      open={open}
      onClose={handleClose}
      title={"Edit Client Description"}
      actions={actions}
    >
        <Form
          mode={ClientDescriptionFormMode.EDIT}
          entity={internalEntry}
          tags={tagsFromApi}
          engineFamilies={familiesFromApi}
          errors={errors}
          setEntity={setInternalEntry}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
        />
    </GenericDialog>
  );
}
